import { combineReducers } from "redux";
import clasificacionReducer from "./Clasificacion.reducer";
import catalogoReducer from "./Catalogo.reducer";
import loginReducer from "./Login.reducer";
import cotizacionReducer from "./Cotizacion.reducer";
import sucursalReducer from "./Sucursal.reducer";

export default combineReducers({
  clasificacionReducer,
  catalogoReducer,
  loginReducer,
  cotizacionReducer,
  sucursalReducer,
});
